import React from 'react';

// type: lineless, tertiary
// size: x-small small medium large

const BasicIconButton = ({ type = 'lineless', disabled = false, size = 'medium', children, onClick = () => {}, className = '', ...props }) => {
  return (
    <div
      className={`basic-icon-button ${type} ${size} ${disabled ? 'disabled' : 'cursor-pointer'} no-drag ${className}`}
      onClick={e => {
        if (disabled) return;
        onClick(e);
      }}
      {...props}
    >
      {children && children}
    </div>
  );
};

export default BasicIconButton;
